<script lang="ts" setup>
import type { ProductResearchData } from '~/types/product-researches'

defineProps<{
  productResearchData: ProductResearchData
}>()
</script>

<template>
  <article
    class="
      flex min-w-[280px] flex-col justify-between rounded-2xl bg-main-light-gray p-5 md:min-w-[250px] lg:min-w-[290px]
    "
  >
    <p
      class="
        !mb-[60px] line-clamp-6 text-sm leading-[1.43] tracking-[-0.01em] text-main-dark md:text-base
        md:leading-normal
      "
    >
      {{ productResearchData.attributes.conclusion }}
    </p>

    <a
      class="flex min-h-[100px] items-stretch !no-underline"
      :href="productResearchData.attributes.sourceUrl"
      target="_blank"
    >
      <SvgIcon class="!size-9 !fill-transparent" name="custom/research" />

      <p class="ml-2 flex flex-col">
        <strong class="mb-[5px] line-clamp-3 text-sm font-medium leading-[1.43] text-[#434242]">
          {{ productResearchData.attributes.title }}
        </strong>

        <span class="line-clamp-3 text-xs leading-none text-[#7c7c7c]">
          {{ productResearchData.attributes.sourceName }}
        </span>
      </p>
    </a>
  </article>
</template>
